import { render, staticRenderFns } from "./InvitationButton.vue?vue&type=template&id=39bf6fad&"
import script from "./InvitationButton.vue?vue&type=script&lang=js&"
export * from "./InvitationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports